import * as Route from '../utils/serverRoutes';
import {
  transformResponseCollection,
  updateCollectionById,
  payloadToData,
} from '../utils/helpers';
import makeRequest, { uploadFile } from '../utils/makeRequest';

const portfolioTeammate = {
  state: {
    collection: [],
    uploadingImage: false,
  },
  reducers: {
    fetchPortfolioTeammatesReducer(state, { collection }) {
      return { ...state, collection };
    },
    addPortfolioTeammateReducer(state, payload) {
      return { ...state, collection: [...state.collection, payload] };
    },
    updatePortfolioTeammateReducer(state, payload) {
      return {
        ...state,
        collection: updateCollectionById(state.collection, payload.id, payload),
      };
    },
    removePortfolioTeammateReducer(state, { id }) {
      const collection = state.collection.filter((e) => e.id !== id);

      return { ...state, collection };
    },
    updateAttributeReducer(state, payload) {
      return { ...state, ...payload };
    },
  },
  effects: (dispatch) => ({
    fetchPortfolioTeammates(bmcId) {
      makeRequest({
        dispatch,
        url: Route.portfolioTeammates(bmcId),
        success: (response) => {
          dispatch.portfolioTeammate.fetchPortfolioTeammatesReducer({
            collection: transformResponseCollection(response.data.data),
          });
        },
      });
    },
    addPortfolioTeammate(_, state) {
      makeRequest({
        dispatch,
        method: 'post',
        url: Route.portfolioTeammates(state.bmc.current.id),
      });
    },
    updatePortfolioTeammate(payload, state) {
      const data = payloadToData(payload);
      dispatch.portfolioTeammate.updatePortfolioTeammateReducer(data);

      makeRequest({
        dispatch,
        method: 'put',
        url: Route.portfolioTeammate(state.bmc.current.id, payload.id),
        data: { portfolioTeammate: data },
        success: payload.success,
        finish: payload.finish,
      });
    },
    updatePortfolioTeammateImage(payload, state) {
      const { id, name, blob, success } = payload;

      dispatch.portfolioTeammate.updateAttributeReducer({
        uploadingImage: id,
      });

      uploadFile({
        url: Route.portfolioTeammate(state.bmc.current.id, id),
        modelName: 'portfolio_teammate',
        name,
        blob,
        dispatch,
        success: (res) => {
          dispatch.portfolioTeammate.updatePortfolioTeammateReducer({
            id,
            [name]: res.data.data.attributes[name],
          });
          if (success) success();
        },
        finish: () => {
          dispatch.portfolioTeammate.updateAttributeReducer({
            uploadingImage: false,
          });
        },
      });
    },
    updatePortfolioTeammateImageCoords({
      id,
      coords,
      croppedAreaPixels,
      innerCropData,
      zoom,
    }) {
      const name = 'imageCoords';
      const value = {
        ...coords,
        ...croppedAreaPixels,
        cropperData: { ...innerCropData, zoom },
      };

      dispatch.portfolioTeammate.updateAttributeReducer({
        uploadingImage: id,
      });

      dispatch.portfolioTeammate.updatePortfolioTeammate({
        id,
        name,
        value,
        success: (res) => {
          dispatch.portfolioTeammate.updatePortfolioTeammateReducer({
            id,
            [name]: res.data.data.attributes[name],
          });

          dispatch.portfolioTeammate.updatePortfolioTeammateReducer({
            id,
            image: res.data.data.attributes.image,
          });
        },
        finish: () => {
          dispatch.portfolioTeammate.updateAttributeReducer({
            uploadingImage: false,
          });
        },
      });
    },
    removePortfolioTeammate(payload, state) {
      makeRequest({
        dispatch,
        method: 'delete',
        url: Route.portfolioTeammate(state.bmc.current.id, payload.id),
      });
    },
  }),
};

export default portfolioTeammate;
